import { confetti } from "tsparticles-confetti";

const COUNT = 200;
const DEFAULTS = {
  origin: { y: 0.7 },
  zIndex: 2147483647,
  disableForReducedMotion: true,
  colors: ["#f59e0b", "#f97316", "#ef4444", "#fb7185", "#a855f7", "#ffffff"],
};

function fire(particleRatio, opts) {
  const particleCount = Math.floor(COUNT * particleRatio);

  void confetti(
    Object.assign({}, DEFAULTS, opts, {
      particleCount,
      count: particleCount,
    })
  );
}

export function fireTaskCompletedConfetti() {
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}
